import { gql } from '@apollo/client'

export const OPERATION_IS_STIME_RAN = gql`
  query isStimeRan($sf_id: String!) {
    is_stime: isStimeRan(sf_id: $sf_id)
  }
`

export const OPERATION_SSID_CONTEXT = gql`
  query findSsidContext($sf_id: String!) {
    ssids: findRanSsids(sf_id: $sf_id) {
      id
      name
      stime_type
    }
    metkVlans: findRanMetkVlans
    byodVlans: findRanByodVlans
  }
`
const OPERATION_FIND_RAN_ROOMS = gql`
  query findRanRooms(
    $sf_id: String!
    $verbatim: String,
    $created_start_at: String,  
    $created_end_at: String,  
    $offset: Int
    $limit: Int
    $sort_by: String
    $sort_direction: String  
  ) {
    rooms: findRanRooms(
      sf_id: $sf_id
      verbatim: $verbatim
      created_start_at: $created_start_at  
      created_end_at: $created_end_at  
      exclude_devices: true
      offset: $offset
      limit: $limit
      sort_by: $sort_by
      sort_direction: $sort_direction  
    ) {
      id
      name
      created_at
      description
      wifi_psk
      ssid_name
      ssid_id
      vlan
      devices {
        mac
        connected_since
        data_downloaded
        data_uploaded
      }
    }
  }
`

export const OPERATION_FIND_RAN_ROOM = gql`
  query findRanRoom($sf_id: String!, $room_id: Int!) {
    room: findRanRoom(sf_id: $sf_id, room_id: $room_id) {
      id
      name
      created_at
      description
      wifi_psk
      ssid_name
      ssid_id
      vlan
      created_at
      devices {
        mac
        connected_since
        data_downloaded
        data_uploaded
      }
      user {
        first_name
        last_name
      }
    }
  }
`

export const OPERATION_FIND_RAN_ROOMS_REMAINING = gql`
  query findRanRoomsRemaining($sf_id: String!, $ssid_id: ID) {
    count: findRanRoomsRemaining(sf_id: $sf_id, ssid_id: $ssid_id)
  }
`

export const getSsidRemainingAlias = (index: number) => `ssid_${index}`

// Built from a string so that codegen does not try to parse a dynamic document.
export const buildRanRoomsRemainingBySsidQuery = (ssids: { id: string | number }[]) => {
  const fields = ssids.map(
    ({ id }, index) =>
      `${getSsidRemainingAlias(index)}: findRanRoomsRemaining(sf_id: $sf_id, ssid_id: ${JSON.stringify(String(id))})`
  )
  return gql(`
    query findRanRoomsRemainingBySsid($sf_id: String!) {
      ${fields.join('\n')}
    }
  `)
}

export const RAN_ROOM_SSID_FRAGMENT = gql`
  fragment RanRoomSsid on RanRoom {
    ssid_id
  }
`

export const OPERATION_EXPORT_RAN_ROOM = gql`
    query exportRanRoom($sf_id: String!, $room_ids: [Int], $format: String, $language: String) {
        base64: exportRanRooms(sf_id: $sf_id, room_ids: $room_ids, format: $format, language: $language)
    }
`
export const OPERATION_EXPORT_RAN_ROOMS = gql`
  query exportRanRooms($sf_id: String!, $format: String, $language: String, $verbatim: String, $created_start_at: String, $created_end_at: String, $sort_by: String, $sort_direction: String) {
    base64: exportRanRooms(sf_id: $sf_id, format: $format, language: $language, verbatim: $verbatim, created_start_at: $created_start_at, created_end_at: $created_end_at, sort_by: $sort_by, sort_direction: $sort_direction)
  }
`

export default OPERATION_FIND_RAN_ROOMS
